import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ChevronDown, Trash2, Pencil, Download, Undo2, X, UserPlus } from 'lucide-react';

export interface BulkActionsToolbarProps {
  selectedCount: number;
  totalMatching: number;
  onClearSelection: () => void;
  onSelectAllMatching: () => void;
  onBulkDelete: () => void;
  onBulkUpdate: () => void;
  onBulkAssign: () => void;
  onBulkExport: (format: 'csv' | 'xlsx') => void;
  onBulkRestore?: () => void;
  isTrashView?: boolean;
}

export function BulkActionsToolbar({
  selectedCount,
  totalMatching,
  onClearSelection,
  onSelectAllMatching,
  onBulkDelete,
  onBulkUpdate,
  onBulkAssign,
  onBulkExport,
  onBulkRestore,
  isTrashView,
}: BulkActionsToolbarProps) {
  if (selectedCount === 0) return null;

  return (
    <div className="sticky top-0 z-10 flex flex-wrap items-center gap-2 rounded-md border bg-background p-2 shadow-sm">
      <span className="text-sm font-medium">{selectedCount} selected</span>

      {totalMatching > selectedCount && (
        <Button variant="link" size="sm" onClick={onSelectAllMatching}>
          Select all {totalMatching} matching
        </Button>
      )}

      <div className="mx-2 h-4 w-px bg-border" />

      {isTrashView ? (
        <Button variant="outline" size="sm" onClick={onBulkRestore}>
          <Undo2 className="mr-2 h-4 w-4" />
          Restore
        </Button>
      ) : (
        <>
          <Button variant="outline" size="sm" onClick={onBulkUpdate}>
            <Pencil className="mr-2 h-4 w-4" />
            Update
          </Button>
          <Button variant="outline" size="sm" onClick={onBulkAssign}>
            <UserPlus className="mr-2 h-4 w-4" />
            Assign to students
          </Button>
          <Button variant="outline" size="sm" onClick={onBulkDelete}>
            <Trash2 className="mr-2 h-4 w-4" />
            Delete
          </Button>
        </>
      )}

      <DropdownMenu>
        <DropdownMenuTrigger
          render={(p) => (
            <Button {...p} variant="outline" size="sm">
              <Download className="mr-2 h-4 w-4" />
              Export
              <ChevronDown className="ml-1 h-3 w-3" />
            </Button>
          )}
        />
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => onBulkExport('csv')}>Export as CSV</DropdownMenuItem>
          <DropdownMenuItem onClick={() => onBulkExport('xlsx')}>
            Export as XLSX
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <div className="ml-auto">
        <Button variant="ghost" size="sm" onClick={onClearSelection}>
          <X className="mr-2 h-4 w-4" />
          Clear
        </Button>
      </div>
    </div>
  );
}
